import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class Authguard {

  constructor(
    private _router: Router
  ) { }


  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const token = localStorage.getItem('Authorization')
    if (token) {
      return true;
    } else {
      this._router.navigate(['/login']);
      return false;
    }
  }
}
